export enum ApiResultCode {
  RequestSuccessful,
  UnHandledException,
  IdentityServiceUnavailable,
  NotAllowedThisOperation,
  UserSessionInvalidOrExpired,
  InvalidApiKey,
  ClientIdInvalidOrNull,
  AuthenticationHeaderNotFound,
  AuthenticationSchemaNotFound,
  EmptyEntryNotAllowed,
  RoleNotFound,
  EmptyRoleId,
  InvalidRoleId,
  EmptyNameAndDescription,
  IsDefaultAlreadyDefined,
  NotFoundRolesForSoftwareId,
  UserNotAccessToAnySoftware,
  SoftwareNotFound,
  EmptyNameAndBusinessDescription,
  EmptySoftwareId,
  InvalidSoftwareId,
  EmptyUserId,
  InvalidUserId,
  UsernameExist,
  EmailExist,
  PasswordLengthLowerThan8,
  EmailUsernameOrPasswordWrong,
  PasswordAndRePasswordNotMatched,
  EmailNotConfirmed,
  ConfirmationLinkExpired,
  ConfirmationCompletedBefore,
  NotFoundPermissionForSoftwareId,
  EmptyPermissionId,
  InvalidPermissionId,
  EmptyNameSoftwareIdParentId,
  EmptyNamePermissionIdParentId,
  UserAlreadyHasAccessToSoftware,
  NotExistUserAccessToSoftware,
  InvalidRefreshToken,
  RefreshTokenIsDisable,
  RefreshTokenHasBeenExpired,
  CannotRefreshBeforeExpiration,
  LimitOnRefreshTime,
  RoleAlreadyHasAccessToPermission,
  NotExistRoleAccessToPermission,
  UserAlreadyHasAccessToRole,
  NotExistUserAccessToRole,
  ResetPasswordExpiredOrInvalid,
  TooManyRequests,
  EmailAddressConfirmed,
}
